import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-license-plates-boxed',
  templateUrl: './license-plates-boxed.component.html',
  styleUrls: ['./license-plates-boxed.component.scss']
})
export class LicensePlatesBoxedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
